(function () {
  'use strict';

  function initCarousel(sectionEl) {
    if (!sectionEl) return;

    var track   = sectionEl.querySelector('[data-nac-track]');
    var prevBtn = sectionEl.querySelector('[data-nac-prev]');
    var nextBtn = sectionEl.querySelector('[data-nac-next]');
    if (!track) return;

    /* ── Get one card width + gap ── */
    function getCardWidth() {
      var card = track.querySelector('.nac-card');
      if (!card) return 200;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      return card.offsetWidth + gap;
    }

    /* ── Update disabled state of arrows ── */
    function updateArrows() {
      if (!prevBtn && !nextBtn) return;
      var atStart = track.scrollLeft <= 4;
      var atEnd   = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
    }

    /* ── Scroll by one card in given direction ── */
    function scrollDir(dir) {
      track.scrollBy({ left: getCardWidth() * dir, behavior: 'smooth' });
    }

    /* ── Arrow click handlers ── */
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollDir(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollDir(1);
      });
    }

    /* ── Update arrows on every scroll event ── */
    track.addEventListener('scroll', updateArrows, { passive: true });

    /* ── Update arrows after touch swipe ends ── */
    track.addEventListener('touchend', function () {
      setTimeout(updateArrows, 400);
    }, { passive: true });

    /* ── Keyboard support when track is focused ── */
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { scrollDir(-1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { scrollDir(1);  e.preventDefault(); }
    });

    /* ── Recalc on resize ── */
    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        updateArrows();
      }).observe(track);
    } else {
      window.addEventListener('resize', updateArrows);
    }

    /* ── Initial arrow state ── */
    updateArrows();
  }

  function init() {
    document.querySelectorAll('[data-section-type="new-arrivals-carousel"]')
      .forEach(initCarousel);
  }

  /* Defer after window.load — never competes with LCP */
  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }

  /* Shopify theme editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[data-section-type="new-arrivals-carousel"]');
    if (sec) initCarousel(sec);
  });

})();